// Deep-link guards for the /advertise funnel: if a step's prerequisite data
// isn't in the store yet (e.g. user pasted a mid-funnel URL), send them back
// to that track's landing page instead of rendering a broken step.
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useStepGuard(isValid, redirectTo) {
  const navigate = useNavigate();
  useEffect(() => {
    if (!isValid) navigate(redirectTo, { replace: true });
  }, [isValid, redirectTo, navigate]);
}

export const agentsStepValid = {
  profile: (s) => !!s.plan,
  goals: (s) => !!s.plan && !!s.email && !!s.firstName,
  schedule: (s) => !!s.plan && !!s.email,
  review: (s) => !!s.plan && !!s.email,
  'thank-you': () => true,
};

export const sellersStepValid = {
  verify: (s) => !!s.address,
  details: (s) => !!s.address,
  contact: (s) => !!s.role,
  review: (s) => !!s.role && !!s.email,
  checkout: (s) => !!s.quoteId,
  'thank-you': () => true,
};

export const buildersStepValid = {
  portfolio: (s) => !!s.companyName,
  contact: (s) => !!s.companyName,
  schedule: (s) => !!s.email,
  review: (s) => !!s.email,
  'thank-you': () => true,
};
